export default {
    videoNotLoaded: "Vídeo não disponível no seu navegador",
    next: "Próximo",
    previous: "Anterior",
    skipAll: "Pular tudo",
    finish: "Finalizar",
    skipTutorial: "Pular tutorial",
    startTutorial: "Iniciar tutorial",
    welcome: {
        title: "Bem-vindo a bordo!",
        subtitle:
            "Este guia rápido leva apenas 2 minutos e vai te ajudar a se familiarizar com a plataforma em poucos passos.",
        describe:
            "É um mundo virtual onde equipes se encontram, conversam e colaboram naturalmente",
        describe2: " — como na vida real.",
        describe3: "Neste tutorial, você vai aprender a:",
        bloc1: "Se movimentar",
        bloc2: "Conversar com outras pessoas",
        bloc3: "Descobrir objetos interativos",
    },
    step1: {
        title: "Explore seu mundo",
        use: "Use as",
        arrowkeys: " setas do teclado",
        or: "ou",
        wasd: "WASD para mover seu avatar",
        aroundTheMap: "pelo mapa. Experimente agora!",
        tip: "Dica:",
        describeTip:
            "Segure a tecla Shift enquanto se move para andar mais rápido — perfeito se estiver com pressa ou quiser explorar mais rápido!",
        silentZone: "Você está em uma Zona Silenciosa — aqui, ninguém pode te ouvir.",
    },
    step2: {
        title: "Converse & colabore",
        describe: "Para iniciar uma conversa, aproxime-se de alguém ",
        describe2: " — o vídeo ou áudio será iniciado automaticamente.",
        describe3: "Clique no ícone de cadeado para trancar a conversa e torná-la privada.",
        describe4: "Clique no botão “Compartilhar Tela” durante uma conversa para mostrar sua tela",
    },
    step3: {
        title: "Descubra & Interaja",
        interact: "Interaja com objetos ",
        likeSign: "como placas, telas, documentos e portais",
        sometimes: "— às vezes eles acendem ",
        closer: "quando você se aproxima.",
        describe3:
            "Reúna pessoas em salas de reunião, promovendo discussões espontâneas e trabalho em equipe.",
        describe4:
            "Faça uma pausa em zonas silenciosas, o lugar perfeito para focar e trabalhar sem interrupções.",
    },
};
